import { EtfBackendViewModel } from '../model/backend';

const apiBaseUrl = process.env.REACT_APP_INTEGRATION_SCREENER_URI!;

export const EtfService = {
	async fetchData(): Promise<EtfBackendViewModel[]> {
		const response = await fetch(apiBaseUrl);
		const parsedBody = await response.json();
		return parsedBody;
	}
}
